import { Action } from '@ngrx/store'

export const USER_LOGOUT = 'UserLogout'

export class UserLogout implements Action {
  readonly type = USER_LOGOUT
}

export type All = UserLogout
